import { AmountSuperScript } from "components/design/AmountSuperScript";
import React from "react";
import { QuarterlyAdvanceTaxMetadata } from "store/apis/products";

export const AdvanceQuarterlyTaxPrice = ({
  quarterData,
}: {
  quarterData: QuarterlyAdvanceTaxMetadata[0] | undefined;
}) => {
  if (!quarterData) {
    return <p className="t-text-subtitle">NA</p>;
  }

  return (
    <p className="t-text-subtitle">
      <AmountSuperScript amount={Number(quarterData?.price || 0)} />
    </p>
  );
};
